import React, { ReactNode, useEffect, useRef } from 'react'
import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import {
  ProductAnalyticsContext,
  ProductAnalyticsContextValue,
} from 'features/product-analytics/ProductAnalyticsProvider'
import { noop } from 'lodash'
import { ProductEvents } from 'features/product-analytics/Events.types'

const PROXY_URL = process.env.VF_LOGROCKET_PROXY_URL || ''
const APP_ID = process.env.CT_LOGROCKET_APP_ID || ''

export default function LogRocketAnalyticsProvider({ children }: { children: ReactNode }) {
  const client = useRef<typeof LogRocket | null>(null)

  useEffect(() => {
    if (!client.current) {
      LogRocket.init(APP_ID, { ingestServer: PROXY_URL })
      setupLogRocketReact(LogRocket)
      client.current = LogRocket
    }
  }, [])

  function identify(
    id: Parameters<ProductAnalyticsContextValue['identify']>[0],
    traits: Parameters<ProductAnalyticsContextValue['identify']>[1]
  ) {
    client.current?.identify(id, traits)
  }

  function trackEvent(event: ProductEvents) {
    let name: string = event.type
    let properties: any = event.payload

    switch (event.type) {
      case 'ConnectionQualityReported':
        name = `ConnectionQuality--${event.payload.quality}`
        properties = undefined
        break
      case 'ConnectionStatusReported':
        name = `ConnectionStatus--${event.payload.online ? 'Online' : 'Offline'}`
        properties = undefined
        break
      default:
        break
    }

    client.current?.track(name, properties)
  }

  function reset() {
    noop() // it does not appear that LogRocket offers a way to reset the client
  }

  return (
    <ProductAnalyticsContext.Provider value={{ identify, trackEvent, reset }}>
      {children}
    </ProductAnalyticsContext.Provider>
  )
}
